'use client';

import { useState } from 'react';
import { useWorkflowStore } from '../../../stores/workflowStore';
import { Info } from '@phosphor-icons/react';

interface AppendConfigProps {
  nodeId: string;
  config: { ignoreSchema?: boolean };
}

export function AppendConfig({ nodeId, config }: AppendConfigProps) {
  const { updateNodeConfig } = useWorkflowStore();
  const [ignoreSchema, setIgnoreSchema] = useState(config.ignoreSchema || false);

  const handleChange = (checked: boolean) => {
    setIgnoreSchema(checked);
    updateNodeConfig(nodeId, { type: 'append', params: { ignoreSchema: checked } });
  };

  return (
    <div className="space-y-4">
      <label className="flex items-start gap-3 cursor-pointer p-3 rounded-xl border border-zinc-200 hover:border-zinc-300 transition-colors">
        <input type="checkbox" checked={ignoreSchema}
          onChange={(e) => handleChange(e.target.checked)}
          className="mt-0.5 w-4 h-4 text-emerald-600 rounded border-zinc-300 focus:ring-emerald-500"
        />
        <div>
          <div className="text-sm font-medium text-zinc-800">忽略 Schema 差异</div>
          <div className="text-xs text-zinc-500 mt-0.5">允许列结构不同的表进行追加合并，缺失的列将填充空值</div>
        </div>
      </label>

      <div className="flex items-start gap-2 p-3 bg-blue-50 rounded-xl border border-blue-100">
        <Info className="w-4 h-4 text-blue-500 flex-shrink-0 mt-0.5" />
        <p className="text-xs text-blue-700">追加节点将多个数据源按行合并（UNION ALL），需要在画布上连接多个输入节点。</p>
      </div>
    </div>
  );
}
